import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  FormControlLabel,
  Checkbox,
  Button,
  Grid,
  Rating,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  Divider,
} from "@mui/material";
import "./PatientFeedBackForm.css";
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import CommonValidation from "../CommonFunctions/CommonValidation";
import { ToastMsg } from "../CommonFunctions/CommonFuntions";
import { formGet, post } from "../../Utility/RestAPIService";
import ImagePaths from "../../Utility/ImagePaths";
import { feedbacklabel } from "../../Utility/Constants";

const chooseValue = [
  { label: "Poor", value: 1 },
  { label: "Fair", value: 2 },
  { label: "Good", value: 3 },
  { label: "Very Good", value: 4 },
  { label: "Excellent", value: 5 }
]

const PatientFeedBackForm = () => {
  const [formState, setFormState] = useState({
    // basic info
    typeOfVisit: "",
    departmentVisited: "",
    dateOfVisit: "",
    // experience
    consultantDoctor: "",
    timelyMedication: "",
    // appointment
    easeOfAppointment: "",
    infoRegardingDoctor: "",
    registrationCourtesy: "",
    // waiting
    waitingComfort: "",
    // staff
    staffCourtesy: "",
    // pharmacy
    pharmacyAvailability: "",
    pharmacyCourtesy: "",
    // billing
    billingTransparency: "",
    // overall
    overallExperience: "",
    // reasons (each checkbox as individual boolean)
    reasons: [],
    otherReason: '',
    // nps
    nps: 0,
    // feedback
    feedback: "",
    // contact
    contactPermission: true,
    Alt_mobile: "",
    token: '',
    clinicID: null,
    clinicName: '',
    branchID: null,
    OrgID: null,
    AppID: null,
    isexpiry: false,
  });
  const [IsErrorMsg, setIsErrorMsg] = useState(false)
  const [IsErrorMsgText, setIsErrorMsgText] = useState('')
  const [successMsg, setsuccessMsg] = useState(false)
  const [aldSubmitForm, setAldSubmitForm] = useState(false)
  const [successMsgText, setsuccessMsgText] = useState('')
  const [language, setLanguage] = useState('tamil')

  const errorMessage = (message) => {
    setIsErrorMsg(true)
    setIsErrorMsgText(message)
  }

  const successMessage = (message) => {
    setsuccessMsg(true)
    setsuccessMsgText(message)
  }

  console.log(formState)

  useEffect(() => {
    const queryString = window.location.search;
    console.log(queryString, 'queryString')
    const urlParams = new URLSearchParams(queryString)
    console.log(urlParams, 'urlParams')
    const tokenFromUrl = urlParams.get('token')
    console.log(tokenFromUrl, 'tokenFromUrl')

    if (tokenFromUrl) {
      setFormState((prev) => ({
        ...prev,
        token: tokenFromUrl,
      }));
    }
  }, [])

  useEffect(() => {
    if (formState.token) {
      getClinicData();
    }
  }, [formState.token])

  const getClinicData = () => {
    try {
      let GET_CLINIC_DATA = `fo/feedback-token-details/`
      formGet(GET_CLINIC_DATA, formState.token).then((response) => {
        if (response.data.status === 'success') {
          let data = response.data.data
          setFormState((prev) => ({
            ...prev,
            clinicID: data?.clinic_data?.clinic_id,
            clinicName: data?.clinic_data?.clinic_name,
            branchID: data?.branch_id,
            OrgID: data?.organization_id,
            typeOfVisit: data?.type_of_visit,
            departmentVisited: data?.department_visited,
            dateOfVisit: data?.date_of_visit,
            AppID: data?.appointment_id,
            isexpiry: response?.data?.is_expired || false,
          }));
          setLanguage(response?.data?.data?.regional_language || 'tamil')
          setAldSubmitForm(response.data?.is_feedback_submitted )
        }
      }).catch((error) => {
         if (error?.response?.data?.is_feedback_submitted) {
          setAldSubmitForm(error?.response?.data?.is_feedback_submitted )
        }else if(error?.response?.data?.message){
          errorMessage(error.response.data.message)
        } else {
          errorMessage(error.message)
        }
      })
    } catch (error) {
      errorMessage(error.message)
    }
  }
  
  const sendFeedBack = () => {
    try {
      if (
        !formState?.consultantDoctor ||
        !formState?.timelyMedication ||
        !formState?.easeOfAppointment ||
        !formState?.infoRegardingDoctor ||
        !formState?.registrationCourtesy ||
        !formState?.waitingComfort ||
        !formState?.staffCourtesy ||
        !formState?.pharmacyAvailability ||
        !formState?.pharmacyCourtesy ||
        !formState?.billingTransparency ||
        !formState?.overallExperience ||
        !formState?.nps ||
        (formState?.reasons?.length ?? 0) === 0
      ) {
        errorMessage("Please fill all mandatory fields before submitting feedback.");
        return;
      }
      if (formState?.reasons?.includes("Other") && !formState?.otherReason?.trim()) {
        errorMessage("Please specify the reason under 'Other'.");
        return;
      }
      let data = {
        "organization_id": formState?.OrgID || null,
        "branch_id": formState?.branchID || null,
        "clinic_id": formState?.clinicID || null,
        "visit_type": formState?.typeOfVisit || '',
        "department_visited": formState?.departmentVisited || '',
        "date_of_visit": formState?.dateOfVisit ? new Date(formState.dateOfVisit).toISOString().split("T")[0] : null,
        "consultant_doctor_rating": +formState?.consultantDoctor || null,
        "timely_medication_and_care": +formState?.timelyMedication || null,
        "ease_of_getting_appointment": +formState?.easeOfAppointment || null,
        "information_regarding_doctor": +formState?.infoRegardingDoctor || null,
        "warmth_and_courtesy_at_registration": +formState?.registrationCourtesy || null,
        "comfort_while_waiting": +formState?.waitingComfort || null,
        "courtesy_and_helpfulness_of_staff": +formState?.staffCourtesy || null,
        "availability_of_prescribed_medicines": +formState?.pharmacyAvailability || null,
        "pharmacy_courtesy_and_speed": +formState?.pharmacyCourtesy || null,
        "clarity_transparancy_billing": +formState?.billingTransparency || null,
        "overall_experience": +formState?.overallExperience || null,
        "other_reason_text": formState?.otherReason.trim() || '',
        "reasons": formState?.reasons || [],
        "nps": +formState?.nps || null,
        "feedback_text": formState?.feedback.trim() || '',

        "allow_contact": formState?.contactPermission,
        "mobile_number": formState?.Alt_mobile.trim() || '',
        "appointment_id": formState?.AppID || null,
      }
      let GET_CLINIC_DATA = `fo/feedback/hospital/`
      post(GET_CLINIC_DATA, data).then((response) => {
        if (response.data.status === 'success') {
          setAldSubmitForm(true)
          // successMessage("Thank you! Your feedback has been submitted successfully" || response.data.message)
          setFormState((prev) => ({
            ...prev,
            isexpiry: response?.data?.is_expired || false
          }))
          clearFeilds()
        }
      }).catch((error) => {
        if (error?.response?.data?.message) {
          errorMessage(error.response.data.message)
        } else {
          errorMessage(error.message)
        }
      })
    } catch (error) {
      errorMessage(error.message)
    }
  }
  const clearFeilds = () => {
    setFormState((prev) => ({
      ...prev,
      consultantDoctor: "",
      timelyMedication: "",
      easeOfAppointment: "",
      infoRegardingDoctor: "",
      registrationCourtesy: "",
      waitingComfort: "",
      staffCourtesy: "",
      pharmacyAvailability: "",
      pharmacyCourtesy: "",
      billingTransparency: "",
      overallExperience: "",
      otherReason: "",
      reasons: [],
      feedback: "",
      contactPermission: true,
      Alt_mobile: "",
      nps: 0,
    }))
  }

  // 🔹 Generic handler for text/radio inputs
  const handleChange = (field, value) => {
    setFormState((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // Checkbox handler (stores true/false)
  const handleCheckboxChange = (reasonKey) => {
    setFormState((prev) => {
      const currentReasons = prev.reasons || [];

      if (currentReasons.includes(reasonKey)) {
        // Remove if already exists
        const updatedReasons = currentReasons.filter(item => item !== reasonKey);

        // If removing "other", also clear the otherReason text
        if (reasonKey === "Other") {
          return {
            ...prev,
            reasons: updatedReasons,
            otherReason: "" // Clear the text when unchecking
          };
        }

        return {
          ...prev,
          reasons: updatedReasons
        };
      } else {
        // Add if not exists
        return {
          ...prev,
          reasons: [...currentReasons, reasonKey]
        };
      }
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Data:", formState);
  };

  const msgClose = () => {
    setIsErrorMsg(false)
    setIsErrorMsgText('')
    setsuccessMsg(false)
    setsuccessMsgText('')
  }

  const fontSizeMalayalam = language === "malayalam" ? "0.8rem" : "0.9rem"
  const isMalayalam = language === "ml";

  return (
    <Box className="feedback-container" component="form" onSubmit={handleSubmit}>
      <Box sx={{mt:2}} className="feedback-header">
        <Typography variant="h6" className="feedback-title">
          {`${formState.clinicName} Digital Patient Feedback Form`} / <span style={{fontSize:fontSizeMalayalam}}>{feedbacklabel[language]?.hospital_feedback_form}</span>
        </Typography>
        <Typography variant="body2" className="feedback-subtitle">
          We hope your experience at our hospital has been comfortable. Please
          take a few moments to complete this survey to help us improve our
          services. / <span style={{fontSize:fontSizeMalayalam}}>{feedbacklabel[language]?.experience_intro}</span>
        </Typography>
      </Box>

      {/* Patient Information */}
      <Box className="feedback-section">
        <Typography
          className="section-title"
          sx={{ fontSize: isMalayalam ? "0.85rem" : "1rem" }}
        >
          Patient Information /<span style={{fontSize:fontSizeMalayalam}}>{feedbacklabel[language]?.patient_information}</span>
        </Typography>

        <FormControl component="fieldset" className="form-control">
          <FormLabel  sx={{ fontSize: isMalayalam ? "0.8rem" : "0.9rem" , color: "#333","&.Mui-focused": { color: "#333" }}}>
            Type of Visit / <span styl sx={{ color: "#333","&.Mui-focused": { color: "#333" },}}e={{fontSize:fontSizeMalayalam}}>{feedbacklabel[language]?.type_of_visit}</span>
          </FormLabel>

          <RadioGroup
            sx={{ marginLeft: "0.7rem" }}
            row
            value={formState.typeOfVisit}
            onChange={(e) => handleChange("typeOfVisit", e.target.value)}
          >
            <FormControlLabel
              disabled
              value="OPD"
              control={<Radio size="small" />}
              label={
                <span style={{ fontSize: isMalayalam ? "0.8rem" : "0.9rem" }}>
                  OPD / {feedbacklabel[language]?.opd}
                </span>
              }
            />

            <FormControlLabel
              disabled
              value="IPD"
              control={<Radio size="small" />}
              label={
                <span style={{ fontSize: isMalayalam ? "0.8rem" : "0.9rem" }}>
                  IPD / {feedbacklabel[language]?.ipd}
                </span>
              }
            />

            <FormControlLabel
              disabled
              value="EMERGENCY"
              control={<Radio size="small" />}
              label={
                <span style={{ fontSize: isMalayalam ? "0.8rem" : "0.9rem" }}>
                  Emergency / {feedbacklabel[language]?.emergency}
                </span>
              }
            />
          </RadioGroup>
        </FormControl>

        <TextField
          fullWidth
          label={`Department Visited / ${feedbacklabel[language]?.department_visited}`}
          variant="outlined"
          disabled
          size="small"
          value={formState.departmentVisited}
          onChange={(e) => handleChange("departmentVisited", e.target.value)}
          className="text-field"
          inputProps={{ maxLength: 60 }}
          InputLabelProps={{
            style: { fontSize: isMalayalam ? "0.8rem" : "0.9rem" },
          }}
        />

        <TextField
          fullWidth
          label={`Date of Visit / ${feedbacklabel[language]?.date_of_visit}`}
          type="text"
          disabled
          InputLabelProps={{
            shrink: true,
            style: { fontSize: isMalayalam ? "0.8rem" : "0.9rem" },
          }}
          size="small"
          value={
            formState.dateOfVisit
              ? new Date(formState.dateOfVisit).toLocaleDateString("en-GB")
              : ""
          }
          className="text-field"
          sx={{ marginTop: "1rem" }}
        />
      </Box>


      {/* Experience */}
      <Box className="feedback-section">
        <Box sx={{ display: 'flex', flexDirection: 'row' }}>
          <Typography className="section-title">
            Experience With Doctor and Care / <span style={{fontSize:fontSizeMalayalam}}>{feedbacklabel[language]?.doctor_experience}</span>
          </Typography>
          <Box
            component="img"
            src={ImagePaths.Mandatory.default}
            alt="mandatory"
            sx={{
              width: "0.5rem",
              height: "0.5rem",
            }}
          />
        </Box>

        <FormControl className="form-control">
          <FormLabel sx={{ color: "#333","&.Mui-focused": { color: "#333" },}}>Consultant Doctor / <span style={{fontSize:fontSizeMalayalam}}>{feedbacklabel[language]?.consultant_doctor}</span></FormLabel>
          <RadioGroup
            sx={{ marginLeft: "0.7rem" }}
            row
            value={formState.consultantDoctor}
            onChange={(e) => handleChange("consultantDoctor", e.target.value)}
          >
            {chooseValue.map((rate) => (
              <FormControlLabel disabled={formState?.isexpiry} key={rate.value} value={rate.value} control={<Radio size="small" />} label={rate.label} />
            ))}
          </RadioGroup>
        </FormControl>

        <FormControl className="form-control">
          <FormLabel sx={{ color: "#333","&.Mui-focused": { color: "#333" }}}>Timely Medication & Care / <span style={{fontSize:fontSizeMalayalam}}>{feedbacklabel[language]?.timely_medication_care}</span></FormLabel>
          <RadioGroup
            sx={{ marginLeft: "0.7rem" }}
            row
            value={formState.timelyMedication}
            onChange={(e) => handleChange("timelyMedication", e.target.value)}
          >
            {chooseValue.map((rate) => (
              <FormControlLabel disabled={formState?.isexpiry} key={rate.value} value={rate.value} control={<Radio size="small" />} label={rate.label} />
            ))}
          </RadioGroup>
        </FormControl>
      </Box>

      {/* Appointment */}
      <Box className="feedback-section">
        <Box sx={{ display: 'flex', flexDirection: 'row' }}>
          <Typography className="section-title">
            Appointment and Registration / <span style={{fontSize:fontSizeMalayalam}}>{feedbacklabel[language]?.appointment_registration}</span>
          </Typography>
          <Box
            component="img"
            src={ImagePaths.Mandatory.default}
            alt="mandatory"
            sx={{
              width: "0.5rem",
              height: "0.5rem",
            }}
          />
        </Box>
        <FormControl className="form-control">
          <FormLabel sx={{ color: "#333","&.Mui-focused": { color: "#333" },}}>Ease of getting an appointment / <span style={{fontSize:fontSizeMalayalam}}>{feedbacklabel[language]?.ease_of_appointment}</span></FormLabel>
          <RadioGroup
            sx={{ marginLeft: "0.7rem" }}
            row
            value={formState.easeOfAppointment}
            onChange={(e) => handleChange("easeOfAppointment", e.target.value)}
          >
            {chooseValue.map((rate) => (
              <FormControlLabel disabled={formState?.isexpiry} key={rate.value} value={rate.value} control={<Radio size="small" />} label={rate.label} />
            ))}
          </RadioGroup>
        </FormControl>

        <FormControl className="form-control">
          <FormLabel sx={{ color: "#333","&.Mui-focused": { color: "#333" }}}>Information regarding doctor /<span style={{fontSize:fontSizeMalayalam}}>{feedbacklabel[language]?.info_about_doctor}</span></FormLabel>
          <RadioGroup
            sx={{ marginLeft: "0.7rem" }}
            row
            value={formState.infoRegardingDoctor}
            onChange={(e) => handleChange("infoRegardingDoctor", e.target.value)}
          >
            {chooseValue.map((rate) => (
              <FormControlLabel disabled={formState?.isexpiry} key={rate.value} value={rate.value} control={<Radio size="small" />} label={rate.label} />
            ))}
          </RadioGroup>
        </FormControl>

        <FormControl className="form-control">
          <FormLabel sx={{ color: "#333","&.Mui-focused": { color: "#333" }}}>Warmth & courtesy at registration desk / <span style={{fontSize:fontSizeMalayalam}}>{feedbacklabel[language]?.registration_courtesy}</span></FormLabel>
          <RadioGroup
            sx={{ marginLeft: "0.7rem" }}
            row
            value={formState.registrationCourtesy}
            onChange={(e) => handleChange("registrationCourtesy", e.target.value)}
          >
            {chooseValue.map((rate) => (
              <FormControlLabel disabled={formState?.isexpiry} key={rate.value} value={rate.value} control={<Radio size="small" />} label={rate.label} />
            ))}
          </RadioGroup>
        </FormControl>
      </Box>

      {/* Waiting */}
      <Box className="feedback-section">
        <Box sx={{ display: 'flex', flexDirection: 'row' }}>
          <Typography className="section-title">
            Waiting Time / <span style={{fontSize:fontSizeMalayalam}}>{feedbacklabel[language]?.waiting_time}</span>
          </Typography>
          <Box
            component="img"
            src={ImagePaths.Mandatory.default}
            alt="mandatory"
            sx={{
              width: "0.5rem",
              height: "0.5rem",
            }}
          />
        </Box>
        <FormControl className="form-control">
          <FormLabel sx={{ color: "#333","&.Mui-focused": { color: "#333" },}}>Comfort while waiting for your turn / <span style={{fontSize:fontSizeMalayalam}}>{feedbacklabel[language]?.waiting_comfort}</span></FormLabel>
          <RadioGroup
            sx={{ marginLeft: "0.7rem" }}
            row
            value={formState.waitingComfort}
            onChange={(e) => handleChange("waitingComfort", e.target.value)}
          >
            {chooseValue.map((rate) => (
              <FormControlLabel disabled={formState?.isexpiry} key={rate.value} value={rate.value} control={<Radio size="small" />} label={rate.label} />
            ))}
          </RadioGroup>
        </FormControl>
      </Box>

      {/* Staff */}
      <Box className="feedback-section">
        <Box sx={{ display: 'flex', flexDirection: 'row' }}>
          <Typography className="section-title">
            Staff Behaviour and Communication / <span style={{fontSize:fontSizeMalayalam}}>{feedbacklabel[language]?.staff_behavior}</span>
          </Typography>
          <Box
            component="img"
            src={ImagePaths.Mandatory.default}
            alt="mandatory"
            sx={{
              width: "0.5rem",
              height: "0.5rem",
            }}
          />
        </Box>
        <FormControl className="form-control">
          <FormLabel sx={{ color: "#333","&.Mui-focused": { color: "#333" }}}>Courtesy and helpfulness of hospital staff / <span style={{fontSize:fontSizeMalayalam}}> {feedbacklabel[language]?.staff_courtesy}</span></FormLabel>
          <RadioGroup
            sx={{ marginLeft: "0.7rem" }}
            row
            value={formState.staffCourtesy}
            onChange={(e) => handleChange("staffCourtesy", e.target.value)}
          >
            {chooseValue.map((rate) => (
              <FormControlLabel disabled={formState?.isexpiry} key={rate.value} value={rate.value} control={<Radio size="small" />} label={rate.label} />
            ))}
          </RadioGroup>
        </FormControl>
      </Box>

      {/* Pharmacy */}
      <Box className="feedback-section">
        <Box sx={{ display: 'flex', flexDirection: 'row' }}>
          <Typography className="section-title">
            Pharmacy Experience / <span style={{fontSize:fontSizeMalayalam}}>{feedbacklabel[language]?.pharmacy_experience}</span>
          </Typography>
          <Box
            component="img"
            src={ImagePaths.Mandatory.default}
            alt="mandatory"
            sx={{
              width: "0.5rem",
              height: "0.5rem",
            }}
          />
        </Box>
        <FormControl className="form-control">
          <FormLabel sx={{ color: "#333","&.Mui-focused": { color: "#333" }}}>Availability of prescribed medicines / <span style={{fontSize:fontSizeMalayalam}}>{feedbacklabel[language]?.medicine_availability}</span></FormLabel>
          <RadioGroup
            sx={{ marginLeft: "0.7rem" }}
            row
            value={formState.pharmacyAvailability}
            onChange={(e) => handleChange("pharmacyAvailability", e.target.value)}
          >
            {chooseValue.map((rate) => (
              <FormControlLabel disabled={formState?.isexpiry} key={rate.value} value={rate.value} control={<Radio size="small" />} label={rate.label} />
            ))}
          </RadioGroup>
        </FormControl>

        <FormControl className="form-control">
          <FormLabel sx={{ color: "#333","&.Mui-focused": { color: "#333" }}}>Courtesy & speed of pharmacy service / <span style={{fontSize:fontSizeMalayalam}}>{feedbacklabel[language]?.pharmacy_courtesy_speed}</span></FormLabel>
          <RadioGroup
            sx={{ marginLeft: "0.7rem" }}
            row
            value={formState.pharmacyCourtesy}
            onChange={(e) => handleChange("pharmacyCourtesy", e.target.value)}
          >
            {chooseValue.map((rate) => (
              <FormControlLabel disabled={formState?.isexpiry} key={rate.value} value={rate.value} control={<Radio size="small" />} label={rate.label} />
            ))}
          </RadioGroup>
        </FormControl>
      </Box>

      {/* Billing */}
      <Box className="feedback-section">
        <Box sx={{ display: 'flex', flexDirection: 'row' }}>
          <Typography className="section-title">
            Billing & Payment Process / <span style={{fontSize:fontSizeMalayalam}}>{feedbacklabel[language]?.billing_payment}</span>
          </Typography>
          <Box
            component="img"
            src={ImagePaths.Mandatory.default}
            alt="mandatory"
            sx={{
              width: "0.5rem",
              height: "0.5rem",
            }}
          />
        </Box>
        <FormControl className="form-control">
          <FormLabel sx={{ color: "#333","&.Mui-focused": { color: "#333" }}}>Clarity and transparency of billing / <span style={{fontSize:fontSizeMalayalam}}>{feedbacklabel[language]?.billing_transparency}</span></FormLabel>
          <RadioGroup
            sx={{ marginLeft: "0.7rem" }}
            row
            value={formState.billingTransparency}
            onChange={(e) => handleChange("billingTransparency", e.target.value)}
          >
            {chooseValue.map((rate) => (
              <FormControlLabel disabled={formState?.isexpiry} key={rate.value} value={rate.value} control={<Radio size="small" />} label={rate.label} />
            ))}
          </RadioGroup>
        </FormControl>
      </Box>

      {/* Overall */}
      <Box className="feedback-section">
        <Box sx={{ display: 'flex', flexDirection: 'row' }}>
          <Typography className="section-title">
            Overall Experience / <span style={{fontSize:fontSizeMalayalam}}>{feedbacklabel[language]?.overall_experience}</span>
          </Typography>
          <Box
            component="img"
            src={ImagePaths.Mandatory.default}
            alt="mandatory"
            sx={{
              width: "0.5rem",
              height: "0.5rem",
            }}
          />
        </Box>
        <FormControl className="form-control">
          <FormLabel sx={{ color: "#333","&.Mui-focused": { color: "#333" }}}>Overall experience at the hospital / <span style={{fontSize:fontSizeMalayalam}}>{feedbacklabel[language]?.overall_experience_at_hospital}</span></FormLabel>
          <RadioGroup
            sx={{ marginLeft: "0.7rem" }}
            row
            value={formState.overallExperience}
            onChange={(e) => handleChange("overallExperience", e.target.value)}
          >
            {chooseValue.map((rate) => (
              <FormControlLabel disabled={formState?.isexpiry} key={rate.value} value={rate.value} control={<Radio size="small" />} label={rate.label} />
            ))}
          </RadioGroup>
        </FormControl>
      </Box>

      {/* Why You Chose */}
      <Box className="feedback-section">
        <Typography className="section-title" sx={{ position: "relative", display: "inline-block" }}>Why You Chose This Hospital? / <span style={{fontSize:fontSizeMalayalam}}>{feedbacklabel[language]?.why_choose_hospital}</span>
          <Box
            component="img"
            src={ImagePaths.Mandatory.default}
            alt="mandatory"
            sx={{
              position: "absolute",
              top: "0.2rem",
              right: "-0.7rem",
              width: "0.5rem",
              height: "0.5rem",
            }}
          />
        </Typography>
        <Grid container spacing={1}>
          {[
            {
              key: "Doctor's Recommendation",
              label: (
                <span style={{ fontSize: isMalayalam ? "0.8rem" : ".9rem" }}>
                  Doctor's Recommendation / {feedbacklabel[language]?.doctor_recommendation}
                </span>
              )
            },
            {
              key: "Past Experience",
              label: (
                <span style={{ fontSize: isMalayalam ? "0.8rem" : ".9rem" }}>
                  Past Experience / {feedbacklabel[language]?.past_experience}
                </span>
              )
            },
            {
              key: "Location",
              label: (
                <span style={{ fontSize: isMalayalam ? "0.8rem" : ".9rem" }}>
                  Location / {feedbacklabel[language]?.location}
                </span>
              )
            },
            {
              key: "Online Reviews / Website",
              label: (
                <span style={{ fontSize: isMalayalam ? "0.8rem" : ".9rem" }}>
                  Online Reviews / Website / {feedbacklabel[language]?.online_reviews}
                </span>
              )
            },
            {
              key: "Insurance Requirements",
              label: (
                <span style={{ fontSize: isMalayalam ? "0.8rem" : ".9rem" }}>
                  Insurance Requirements / {feedbacklabel[language]?.insurance_requirement}
                </span>
              )
            },
            {
              key: "Reputation of Hospital",
              label: (
                <span style={{ fontSize: isMalayalam ? "0.8rem" : ".9rem" }}>
                  Reputation of Hospital / {feedbacklabel[language]?.hospital_reputation}
                </span>
              )
            },
            {
              key: "Friend/Relative Recommendation",
              label: (
                <span style={{ fontSize: isMalayalam ? "0.8rem" : ".9rem" }}>
                  Friend/Relative Recommendation / {feedbacklabel[language]?.friend_relative_recommendation}
                </span>
              )
            },
            {
              key: "Other",
              label: (
                <span style={{ fontSize: isMalayalam ? "0.8rem" : "0.9rem" }}>
                  Other / {feedbacklabel[language]?.other_reason}
                </span>
              )
            }
          ]
            .map((item) => (
              <Grid item xs={12} sm={6} key={item.key}>
                <FormControlLabel
                  control={
                    <Checkbox
                      disabled={formState?.isexpiry}
                      checked={formState?.reasons?.includes(item.key) || false}
                      onChange={() => handleCheckboxChange(item.key)}
                    />
                  }
                  label={item.label}
                />
              </Grid>
            ))}
          {/* Show text box at the end when "Other" is checked */}
          {formState?.reasons?.includes("Other") && (
            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                placeholder="Please specify other reason"
                value={formState.otherReason || ""}
                onChange={(e) => {
                  if (e.target.value.length <= 50) {
                    setFormState(prev => ({
                      ...prev,
                      otherReason: e.target.value
                    }));
                  }
                }}
                sx={{ mt: 1 }}
                inputProps={{ maxLength: 50 }}
              />
            </Grid>
          )}
        </Grid>
      </Box>

      {/* NPS */}
      <Box className="feedback-section">
        <Typography className="section-title" sx={{ position: "relative", display: "inline-block" }}>Net Promoter Score (NPS) / <span style={{fontSize:fontSizeMalayalam}}>{feedbacklabel[language]?.nps}</span>
          <Box
            component="img"
            src={ImagePaths.Mandatory.default}
            alt="mandatory"
            sx={{
              position: "absolute",
              top: "0.2rem",
              right: "-0.7rem",
              width: "0.5rem",
              height: "0.5rem",
            }}
          />
        </Typography>
        <Typography variant="body2">
          On a scale of 1–10, how likely are you to recommend this hospital to others? / <span style={{fontSize:fontSizeMalayalam}}>{feedbacklabel[language]?.nps_question}</span>
        </Typography>
        <Rating
          max={10}
          disabled={formState?.isexpiry}
          value={formState.nps}
          sx={{ marginTop: "1rem" }}
          size="large"
          onChange={(e, value) => handleChange("nps", value)}
        />
      </Box>

      {/* Feedback */}
      <Box className="feedback-section">
        <Typography className="section-title">Suggestions / Complaints / Compliments / <span style={{fontSize:fontSizeMalayalam}}>{feedbacklabel[language]?.suggestions}</span></Typography>
        <TextField
          fullWidth
          multiline
          disabled={formState?.isexpiry}
          rows={3}
          label={`Please share your feedback / ${feedbacklabel[language]?.suggestions_placeholder}`}
          variant="outlined"
          value={formState.feedback}
          onChange={(e) => handleChange("feedback", e.target.value)}
          className="text-field"
          inputProps={{ maxLength: 250 }}
        />
      </Box>

      {/* Contact */}
      <Box className="feedback-section">
        <Typography className="section-title">Contact Permission / <span style={{fontSize:fontSizeMalayalam}}>{feedbacklabel[language]?.contact_permission}</span></Typography>
        <FormControl component="fieldset" className="form-control">
          <FormLabel sx={{ color: "#333","&.Mui-focused": { color: "#333" }}}>Would you like us to contact you regarding your feedback? /<span style={{fontSize:fontSizeMalayalam}}>{feedbacklabel[language]?.contact_permission_question}</span></FormLabel>
          <RadioGroup
            sx={{ marginLeft: "0.7rem" }}
            row
            value={formState.contactPermission}
            onChange={(e) => {
              setFormState((prev) => ({
                ...prev,
                contactPermission: e.target.value
              }));
            }}
          >
            <FormControlLabel disabled={formState?.isexpiry} value={true} control={<Radio size="small" />} label={`Yes / ${feedbacklabel[language]?.yes}`} />
            <FormControlLabel disabled={formState?.isexpiry} value={false} control={<Radio size="small" />} label={`No / ${feedbacklabel[language]?.no}`} />
          </RadioGroup>
        </FormControl>
        <Typography sx={{ color: '#676666ff' }}>{`(If you have another number, please provide it. /`}</Typography> <span style={{fontSize:fontSizeMalayalam, color: '#676666ff'}}>{`${feedbacklabel[language]?.please_provide_it})`}</span>
        <TextField
          fullWidth
          label={
            <span>
              Alternative Mobile Number /{" "}
              <span style={{ fontSize: fontSizeMalayalam }}>
                {feedbacklabel[language]?.alternative_mobile}
              </span>
            </span>
          }
          variant="outlined"
          size="small"
          disabled={formState?.isexpiry}
          sx={{ marginTop: '1vw' }}
          value={formState.Alt_mobile}
          inputProps={{ maxLength: 10 }}
          onChange={(e) => {
            if (CommonValidation.numberOnly(e.target.value) || e.target.value === '') {
              setFormState((prev) => ({
                ...prev,
                Alt_mobile: e.target.value
              }));
            }
          }}
          className="text-field"
        />
      </Box>

      <Box textAlign="center" marginTop={2}>
        <Button type="submit" disabled={formState?.isexpiry} size="small" variant="contained" className="submit-button" sx={{ textTransform: "capitalize" }}
          onClick={() => {
            sendFeedBack()
          }}>
          SEND
        </Button>
      </Box>
      {aldSubmitForm && (
        <Dialog
          open={aldSubmitForm}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: "16px",
              textAlign: "center",
              p: 2,
            },
          }}
        >
          <DialogTitle
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              pb: 1,
            }}
          >
            <TaskAltIcon
              sx={{
                fontSize: "8vh",
                color: "success.main",
              }}
            />
          </DialogTitle>



          <DialogContent sx={{ py: 2, mt:2 }}>
            <Typography
              variant="body2"
              sx={{
                // color: "text.secondary",
                lineHeight: 1.6,
                fontSize: "2.3vh",
              }}
            >
             Thank you! Your feedback has been submitted successfully
            </Typography>
          </DialogContent>

          {/* <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
            <Button
              variant="contained"
              size="small"
              sx={{
                borderRadius: "8px",
                textTransform: "none",
                px: 3,
              }}
              onClick={() => setAldSubmitForm(false)}
            >
              OK
            </Button>
          </DialogActions> */}
        </Dialog>
      )}

      {
        IsErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={IsErrorMsgText}
            msgPop={msgClose.bind(this)}
          />
          : null
      }
      {
        successMsg ?
          <ToastMsg
            severity={'success'}
            msg={successMsgText}
            msgPop={msgClose.bind(this)}
          />
          : null
      }
    </Box>
  );
};

export default PatientFeedBackForm;
